/* Template: Gravity forms override
   ========================================================================== */

template.component.gravity_forms_override = function() {

	var $other_choice = $('input[aria-label="Other"]');

	$other_choice.focus(function() {
		$(this).siblings('input')[0].click();
		if($(this).val() === 'Other') {
			$(this).val('');
		}
	});

	$other_choice.blur(function() {
		if($(this).val().replace(' ', '') === '') {
			$(this).val('Other');
		}
	});

	$other_choice.parent('li').css({
		'display': 'block',
		'margin-right': '0',
		'width': '100%'
	});

	$other_choice.css({
		'width': 'calc(100% - 42px)'
	});

};
